<template>
  <div class="page">
    <div class="page-content">
      <div class="collapse-main-content">
        <SiruiSearch
          ref="baseInfoFormRef"
          :query="baseFormData"
          :columns="initColumn1"
          :isQueryPanel="true"
          @resetBtnClick="resetBtnClickHandler"
          @searchBtnClick="searchBtnClickHandler"
          @changeMethod="changeMethod"
        >
        </SiruiSearch>
        <div class="main-content">
          <sirui-table
            ref="siruiTable"
            :buttonList="menuButtonList"
            :loading="loading"
            :data="tableData"
            :paging="true"
            :setting="false"
            :customVisible="true"
            :columns="columnLists"
            @chooseClick="chooseClick"
            @handleSelectionChange="handleSelectionChange"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          >
            <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
            <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
            <vxe-table-column
              align="center"
              v-for="(item, index) in columnLists"
              :key="index"
              :field="item.field"
              :title="item.title ? $t(item.title) : null"
              :visible="item.visible"
              :type="item.type"
              :width="item.width"
            >
              <template v-slot="{ row }">
                <template v-if="item.field === 'repairNo'">
                  <a @click="jumpToRepairBillDetail(row)" href="#" style="color: #009fcc">{{
                    row[item.field]
                  }}</a>
                </template>
                <template v-else-if="item.field === 'workOrderNo'">
                  <a
                    v-for="(workNoItem, workNoIndex) in row[item.field]"
                    :key="workNoIndex"
                    @click.prevent="jumpToWorkOrderDetail(row, workNoItem)"
                    href="#"
                    style="color: #009fcc"
                    >{{ workNoIndex + ',' }}
                  </a>
                </template>
                <template v-else-if="item.field == 'oaUrl'">
                  <a
                    href="javascript:void(0);"
                    v-if="row[item.field]"
                    @click="goOaLink(row[item.field])"
                    >查看</a
                  >
                </template>
                <template v-else>{{ row[item.field] }}</template>
              </template>
            </vxe-table-column>
          </sirui-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { formColumn, columnList } from './columns/tableColumns.js';
  import API from '@/api/property/repairMagement.js';
  import mixin from './mixin.js';

  export default {
    name: 'RepairsManagement',
    mixins: [mixin],
    data() {
      return {
        baseFormData: {
          repairCompanyNo: '',
          repairDepartmentNo: '',
          pageNum: 1,
          pageSize: 20,
        },
        loading: false,
        formColumns: [],
        columnLists: [],
        menuButtonList: [],
        tableData: [], // 表格数据
        multipleSelection: [],
        // idList:[],
      };
    },
    computed: {
      initColumn1() {
        return formColumn(this);
      },
    },
    mounted() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(20);
      this.columnLists = columnList(this);
      this.getButtonList();
      // this.getCompany();
      this.baseFormData.repairCompanyNo = this.userInfo.companyCode;
      this.getDepartment(this.userInfo.companyCode);
      this.getTableData();
    },
    methods: {
      // // 列表工单号、报修单号的样式
      // cellStyle({ column }) {
      //   if (column.property == 'workOrderNo' || column.property == 'repairNo') {
      //     console.log('co', column);
      //     return {
      //       color: '#009fcc',
      //       // cursor: 'pointer',
      //     };
      //   }
      // },
      // 搜索
      async searchBtnClickHandler() {
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        // this.$refs.siruiTable.setPageTotal(this.tableData.length);
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.baseFormData = {
          repairCompanyNo: this.userInfo.companyCode,
          repairDepartmentNo: null,
        };
        this.getTableData();
      },

      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },

      //获取当前列
      async getColumnInfo() {},
      // 分页查询
      async getTableData() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.loading = true;
        const postData = {
          ...this.baseFormData,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        if (postData.repairCompanyNo) {
          postData.repairCompanyNoList = [postData.repairCompanyNo];
        }
        if (postData.repairDepartmentNo) {
          postData.repairDepartmentNoList = [postData.repairDepartmentNo];
        }
        const { data } = await this.$axios.post(API.REPAIRORDER_PAGE, postData);
        this.loading = false;
        console.log('data', data.data);
        if (data.code == 0) {
          this.$refs.siruiTable.setPageTotal(data.data.total);
          let tableData = data.data.records.map((item) => {
            item.workOrderNo = item.workOrderMap;
            return item;
          });
          this.tableData = tableData;
        } else {
          this.$message.error('查询表格数据失败');
          this.tableData = [];
        }
      },

      chooseClick(type) {
        //获取表格上面的按钮
        this[type]();
      },

      withdrawApproval() {
        if (this.judge()) {
          if (this.multipleSelection.some((item) => item.auditStatus != '审核中')) {
            this.$message.error('只有审批中才可以撤回');
            return;
          }
          this.loading = true;
          this.$axios
            .post('/property/repair/withdrawApproval', {
              idList: this.multipleSelection.map((item) => item.id),
            })
            .then((res) => {
              console.log(res);
              this.loading = false;
              const { code, msg } = res.data;
              if (code == 0) {
                this.$message.success('撤回成功');
                this.searchBtnClickHandler();
              } else {
                this.$message.error(msg);
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      },
      withdrawApprovalHandler() {
        if (!this.multipleSelection.length) {
          this.$message({
            type: 'error',
            message: '请选择数据',
          });
          return;
        }
        if (this.multipleSelection.some((item) => !['OA审核中', '05'].includes(item.auditStatus))) {
          this.$message.error('只有OA审批中才可以撤回审批');
          return;
        }
        const ids = this.multipleSelection.map((item) => item.id);
        this.loading = true;
        this.$axios
          .post('/property/repair/withdrawOA', ids)
          .then((res) => {
            console.log(res);
            this.loading = false;
            const { code, msg } = res.data;
            if (code == 0) {
              this.searchBtnClickHandler();
              this.$message.success('撤回成功');
            } else {
              this.$message.error(msg);
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },

      // 选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      // 获取选中的数据列表id
      async getIdList() {
        let ids = this.multipleSelection.map((item) => {
          return item.id;
        });
        this.exportBtnHandler(ids);
      },
      // 添加报修单
      addBtnHandler() {
        let path = {
          path: '/property/repairsManagement/add',
          name: 'addRepairBill',
          meta: {
            keepAlive: true,
            title: '添加报修单',
          },
          query: {
            pageMode: 1,
          },
        };
        this.$router.push(path);
      },

      // 编辑报修单
      editBtnHandler() {
        if (this.judge()) {
          if (
            (this.multipleSelection[0].auditStatus == '待提交' ||
              this.multipleSelection[0].auditStatus == '审核驳回' ||
              this.multipleSelection[0].auditStatus == 'OA审核驳回') &&
            this.multipleSelection[0].repairStatus != '维修关闭'
          ) {
            console.log('编辑保修单id,', this.multipleSelection[0].id);
            let path = {
              path: '/repairsManagement/editRepairBill',
              name: 'editRepairBill',
              meta: {
                keepAlive: true,
                title: '编辑报修单',
              },
              query: {
                pageMode: 2,
                repairId: this.multipleSelection[0].id,
              },
            };
            this.$router.push(path);
          } else {
            this.$message({
              type: 'error',
              message: '该状态的数据不支持编辑，请核实！',
            });
          }
        }
      },

      //派单
      async sendOrderBtnHander() {
        if (this.judge()) {
          let { data } = await this.$axios.post(
            `${API.REPAIRORDER_DETAIL}/${this.multipleSelection[0].id}`
          );
          console.log('派单数据', data);
          if (data.code == 0) {
            if (
              ['OA审核通过', '审核通过'].includes(this.multipleSelection[0].auditStatus) &&
              this.multipleSelection[0].dispatchFlagName != '是' &&
              this.multipleSelection[0].repairStatus != '维修关闭'
            ) {
              let path = {
                path: '/workorderManagement/addWorkorder',
                name: 'AddWorkorder',
                meta: {
                  keepAlive: true,
                  title: '新增工单',
                },
                query: {
                  id: data.data.id,
                  repairNo: data.data.repairNo,
                  // repairProjects: data.data.repairProjects,
                  status: 'dispatch',
                },
              };
              this.$router.push(path);
            } else {
              this.$message({
                type: 'error',
                message: '该状态的数据不支持派单，请核实！',
              });
            }
          }
        }
      },

      //导出
      async exportBtnHandler() {
        let ids = this.multipleSelection.map((item) => {
          return parseInt(item.id);
        });
        this.exportBtn(ids);
      },
      // 导出接口
      async exportBtn(ids) {
        if (this.tableData.length == 0) {
          this.$message.error('暂无数据可导出');
        }
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        this.baseFormData.pageNum = pageNum;
        this.baseFormData.pageSize = pageSize;
        let params = {
          ...this.baseFormData,
          idList: ids,
        };
        this.$axios.post(API.REPAIROEDER_EXPORT, params).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: '导出成功',
              type: 'success',
            });
            window.location.href = res.data.data;
          } else {
            this.$alert('导出操作失败');
          }
        });
      },
      //关闭
      async closeBtnHandler() {
        if (this.judge()) {
          if (this.multipleSelection[0].dispatchFlag == 0) {
            this.$confirm('你确定要关闭该报修单吗', '提示')
              .then(() => {
                this.closeRapairOrder();
              })
              .catch(() => {
                console.log('取消');
              });
          } else {
            this.$message({
              type: 'error',
              message: '该状态的数据不支持关闭，请核实！',
            });
          }
        }
      },
      // 关闭报修单接口
      async closeRapairOrder() {
        let id = parseInt(this.multipleSelection[0].id);
        let { data } = await this.$axios.post(`${API.REPAIRORDER_CLOSE}/${id}`);
        console.log('id', id, typeof id);
        if (data.code == '0') {
          this.$message({
            type: 'sucess',
            message: '关闭成功',
          });
          this.getTableData();
        }
        console.log('关闭报修单');
      },

      // 审核报修单
      auditBtnHandler() {
        if (this.judge()) {
          console.log(
            'this.multipleSelection[0].auditStatus',
            this.multipleSelection[0].auditStatus
          );
          if (
            this.multipleSelection[0].auditStatus == '审核中' &&
            this.multipleSelection[0].repairStatus != '维修关闭'
          ) {
            let path = {
              path: '/repairsManagement/auditRepair',
              name: 'auditRepair',
              meta: {
                keepAlive: true,
                title: '审核报修单',
              },
              query: {
                pageMode: 3,
                repairId: this.multipleSelection[0].id,
              },
            };
            this.$router.push(path);
          } else {
            this.$message({
              type: 'error',
              message: '该状态的数据不支持审核，请核实！',
            });
          }
        }
      },
      // 提交OA审核
      auditOABtnHandler() {
        let isSubmit = true;
        this.multipleSelection.forEach((item) => {
          if (item.auditStatus != '审核通过') {
            isSubmit = false;
            return;
          }
        });
        if (isSubmit) {
          let ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          console.log('ids', ids);
          this.$confirm('你确定要提交OA审核吗', '提示')
            .then(() => {
              this.submitOA(ids);
            })
            .catch(() => {
              console.log('取消');
            });
        } else {
          this.$message({
            type: 'error',
            message: '该状态的数据不支持提交OA审核，请核实！',
          });
        }
      },

      // OA审核
      async submitOA(ids) {
        this.loading = true;
        let { data } = await this.$axios.post(API.REPAIRORDER_SUBMITOA, {
          ids,
          oaId: this.userInfo.oaId,
        });
        this.loading = false;
        if (data.code == 0) {
          this.$message({
            type: 'success',
            message: data.msg,
          });
          this.getTableData();
        } else {
          this.$message.error(data.msg);
        }
      },

      // 删除
      async deleteBtnHandler() {
        if (this.judge()) {
          if (
            this.multipleSelection[0].auditStatus == '待提交' ||
            this.multipleSelection[0].auditStatus == '审核驳回'
          ) {
            this.$confirm('你确认要删除该报修单吗', '提示')
              .then(() => {
                this.deleteRepairOrder();
              })
              .catch(() => {
                console.log('取消');
              });
          } else {
            this.$message({
              type: 'error',
              message: '该状态的数据不支持删除，请核实！',
            });
          }
        }
      },
      // 删除报修单接口
      async deleteRepairOrder() {
        let id = parseInt(this.multipleSelection[0].id);
        let { data } = await this.$axios.post(`${API.REPAIRORDER_DELETE}/${id}`);
        if (data.code == '0') {
          this.$message({
            type: 'success',
            message: '删除成功',
          });
          this.getTableData();
        }
      },
      // 报修单详情
      jumpToRepairBillDetail(row) {
        let path = {
          path: '/repairsManagement/repairBillDetail',
          name: 'repairBillDetail',
          meta: {
            keepAlive: true,
            title: '报修单详情',
          },
          query: {
            pageMode: 4,
            repairId: row.id,
            status: row.auditStatus,
          },
        };
        this.$router.push(path);
      },

      // 工单详情
      jumpToWorkOrderDetail(row, woerkOrderId) {
        let path = {
          path: '/workorderManagement/WorkorderDetail',
          name: 'WorkorderDetail',
          meta: {
            keepAlive: true,
            title: '工单详情',
          },
          query: {
            repairId: row.id,
            workOrderId: woerkOrderId,
          },
        };
        this.$router.push(path);
      },
      // 判断行的选择
      judge() {
        if (this.multipleSelection.length !== 1) {
          this.$message({
            type: 'error',
            message: '请选择一条数据！',
          });
          return false;
        }
        return true;
      },

      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
    },
    components: {
      SiruiSearch,
    },
  };
</script>

<style scoped lang="scss">
  a {
    color: '#009fcc';
  }
</style>
